var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1306,
    viewBox: "0 0 1920 1306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_189_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 678,
    y: 615,
    width: 29,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M706.417 618.589L696.775 644.09L678.025 640.959L687.668 615.458L706.417 618.589Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_189_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M701.108 632.616C699.29 632.727 697.887 632.364 696.436 632.229C694.723 632.063 693.443 633.079 692.179 634.417C690.941 635.736 689.851 637.21 688.925 638.793C688.643 639.278 688.437 639.87 687.823 640.04C687.288 639.538 687.79 638.758 688.027 638.159C688.567 636.843 688.781 635.531 688.978 634.264C689.311 632.227 688.633 630.731 687.153 629.977C686.013 629.386 684.782 628.933 683.59 628.428C683.241 628.287 682.802 628.202 683.103 627.566C683.331 627.096 683.716 627.219 684.032 627.213C685.312 627.177 686.566 627.208 687.853 627.103C689.895 626.946 691.516 625.703 692.786 623.55C693.73 621.97 694.438 620.314 695.137 618.658C695.362 618.116 695.596 617.528 696.192 617.533C696.785 617.549 696.717 618.116 696.63 618.681C696.46 619.669 696.341 620.654 696.18 621.644C695.487 625.819 696.831 628.607 699.354 630.646C699.949 631.123 700.884 631.243 701.108 632.616Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_189_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 929,
    y: 963,
    width: 29,
    height: 29
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M957.398 966.186L947.755 991.687L929.005 988.556L938.648 963.055L957.398 966.186Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_189_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M952.089 980.212C950.27 980.324 948.867 979.961 947.417 979.826C945.703 979.659 944.424 980.676 943.159 982.014C941.922 983.333 940.831 984.806 939.906 986.39C939.623 986.875 939.418 987.467 938.803 987.637C938.268 987.134 938.77 986.355 939.008 985.756C939.548 984.439 939.762 983.128 939.959 981.86C940.291 979.824 939.613 978.328 938.133 977.574C936.994 976.982 935.762 976.53 934.57 976.024C934.222 975.883 933.783 975.799 934.083 975.163C934.311 974.693 934.696 974.816 935.013 974.809C936.292 974.774 937.547 974.805 938.833 974.7C940.876 974.543 942.497 973.299 943.767 971.147C944.711 969.566 945.419 967.911 946.117 966.254C946.343 965.713 946.576 965.125 947.173 965.13C947.766 965.145 947.697 965.713 947.61 966.278C947.44 967.266 947.321 968.251 947.161 969.241C946.467 973.416 947.812 976.204 950.335 978.243C950.929 978.72 951.865 978.84 952.089 980.212Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_189_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1830,
    y: 633,
    width: 29,
    height: 30
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1858.84 636.939L1849.2 662.441L1830.45 659.31L1840.09 633.809L1858.84 636.939Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_189_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1853.53 650.966C1851.71 651.077 1850.31 650.714 1848.86 650.579C1847.15 650.413 1845.87 651.429 1844.6 652.767C1843.37 654.086 1842.28 655.56 1841.35 657.143C1841.07 657.628 1840.86 658.22 1840.25 658.39C1839.71 657.888 1840.22 657.108 1840.45 656.51C1840.99 655.193 1841.21 653.881 1841.4 652.614C1841.74 650.577 1841.06 649.081 1839.58 648.327C1838.44 647.736 1837.21 647.283 1836.02 646.778C1835.67 646.637 1835.23 646.552 1835.53 645.917C1835.76 645.446 1836.14 645.569 1836.46 645.563C1837.74 645.527 1838.99 645.559 1840.28 645.453C1842.32 645.296 1843.94 644.053 1845.21 641.9C1846.16 640.32 1846.86 638.664 1847.56 637.008C1847.79 636.466 1848.02 635.878 1848.62 635.883C1849.21 635.899 1849.14 636.467 1849.05 637.031C1848.89 638.02 1848.77 639.004 1848.61 639.994C1847.91 644.169 1849.26 646.957 1851.78 648.996C1852.37 649.473 1853.31 649.593 1853.53 650.966Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_189_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 266,
    width: 29,
    height: 30
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8438 269.939L24.2013 295.44L5.45149 292.309L15.0939 266.808L33.8438 269.939Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_189_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.535 283.965C26.7161 284.077 25.3131 283.714 23.8626 283.579C22.1493 283.412 20.8697 284.429 19.6052 285.767C18.3676 287.086 17.2775 288.559 16.3516 290.143C16.0691 290.628 15.8636 291.22 15.2494 291.39C14.7141 290.887 15.2165 290.108 15.4539 289.509C15.9937 288.192 16.2078 286.88 16.4049 285.613C16.7375 283.576 16.0594 282.081 14.5794 281.327C13.4398 280.735 12.2084 280.283 11.0165 279.777C10.6676 279.636 10.2287 279.552 10.5292 278.916C10.757 278.446 11.1421 278.569 11.4587 278.562C12.7384 278.527 13.9927 278.558 15.2793 278.453C17.3217 278.296 18.9428 277.052 20.2126 274.9C21.157 273.319 21.8647 271.664 22.5633 270.007C22.7888 269.466 23.022 268.878 23.619 268.883C24.2117 268.898 24.1431 269.466 24.0561 270.031C23.8865 271.019 23.7673 272.004 23.607 272.994C22.9131 277.169 24.2579 279.957 26.7809 281.996C27.375 282.472 28.3109 282.593 28.535 283.965Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_189_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 943,
    y: 31,
    width: 29,
    height: 30
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M971.843 34.939L962.201 60.4402L943.451 57.3093L953.093 31.8081L971.843 34.939Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_189_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M966.534 48.9659C964.715 49.0772 963.312 48.714 961.862 48.5793C960.148 48.4127 958.869 49.4292 957.604 50.7674C956.367 52.0863 955.276 53.5598 954.351 55.1433C954.068 55.6282 953.863 56.2205 953.248 56.3902C952.713 55.8876 953.215 55.1083 953.453 54.5095C953.993 53.1928 954.207 51.881 954.404 50.6136C954.736 48.5769 954.058 47.0814 952.578 46.3272C951.439 45.7359 950.207 45.283 949.016 44.7776C948.667 44.6369 948.228 44.5521 948.528 43.9166C948.756 43.4462 949.141 43.5693 949.458 43.5628C950.737 43.5273 951.992 43.5585 953.278 43.4532C955.321 43.2963 956.942 42.0529 958.212 39.9001C959.156 38.3197 959.864 36.6645 960.562 35.0077C960.788 34.466 961.021 33.8784 961.618 33.8831C962.211 33.8988 962.142 34.4666 962.055 35.0313C961.886 36.0195 961.766 37.0043 961.606 37.9941C960.912 42.1691 962.257 44.9574 964.78 46.996C965.374 47.473 966.31 47.5931 966.534 48.9659Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_189_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 539,
    y: 959,
    width: 29,
    height: 30
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M567.392 962.954L557.75 988.455L539 985.324L548.642 959.823L567.392 962.954Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_189_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.083 976.981C560.264 977.092 558.861 976.729 557.411 976.594C555.698 976.428 554.418 977.444 553.154 978.782C551.916 980.101 550.826 981.575 549.9 983.158C549.617 983.643 549.412 984.236 548.798 984.405C548.262 983.903 548.765 983.123 549.002 982.525C549.542 981.208 549.756 979.896 549.953 978.629C550.286 976.592 549.608 975.097 548.128 974.342C546.988 973.751 545.757 973.298 544.565 972.793C544.216 972.652 543.777 972.567 544.077 971.932C544.305 971.461 544.69 971.584 545.007 971.578C546.287 971.542 547.541 971.574 548.828 971.468C550.87 971.311 552.491 970.068 553.761 967.915C554.705 966.335 555.413 964.68 556.112 963.023C556.337 962.481 556.57 961.894 557.167 961.898C557.76 961.914 557.691 962.482 557.604 963.046C557.435 964.035 557.316 965.019 557.155 966.009C556.461 970.184 557.806 972.973 560.329 975.011C560.923 975.488 561.859 975.608 562.083 976.981Z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_189_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1444,
    y: 844,
    width: 29,
    height: 29
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1472.69 847.359L1463.04 872.86L1444.29 869.729L1453.94 844.228L1472.69 847.359Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_189_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1467.38 861.385C1465.56 861.497 1464.15 861.133 1462.7 860.999C1460.99 860.832 1459.71 861.849 1458.45 863.187C1457.21 864.506 1456.12 865.979 1455.19 867.563C1454.91 868.048 1454.71 868.64 1454.09 868.81C1453.56 868.307 1454.06 867.528 1454.3 866.929C1454.84 865.612 1455.05 864.3 1455.25 863.033C1455.58 860.996 1454.9 859.501 1453.42 858.747C1452.28 858.155 1451.05 857.702 1449.86 857.197C1449.51 857.056 1449.07 856.972 1449.37 856.336C1449.6 855.866 1449.98 855.989 1450.3 855.982C1451.58 855.947 1452.83 855.978 1454.12 855.873C1456.16 855.716 1457.78 854.472 1459.05 852.32C1460 850.739 1460.71 849.084 1461.4 847.427C1461.63 846.885 1461.86 846.298 1462.46 846.302C1463.05 846.318 1462.98 846.886 1462.9 847.451C1462.73 848.439 1462.61 849.424 1462.45 850.414C1461.75 854.589 1463.1 857.377 1465.62 859.415C1466.22 859.892 1467.15 860.012 1467.38 861.385Z",
    fill: "#FAFAFA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars1);
export default __webpack_public_path__ + "static/media/stars1.1600393d4a555b66609d6957483de9af.svg";
export { ForwardRef as ReactComponent };